import { render, staticRenderFns } from "./leaveform.vue?vue&type=template&id=248ea1f0&scoped=true&"
import script from "./leaveform.vue?vue&type=script&lang=js&"
export * from "./leaveform.vue?vue&type=script&lang=js&"
import style0 from "./leaveform.vue?vue&type=style&index=0&id=248ea1f0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248ea1f0",
  null
  
)

export default component.exports